export interface DscWorkbenchKeyArguments {
  approvalId: string;
}

/**
 * Hierarchical query-key factory for the DSC Workbench dashboard. The shape
 * mirrors `stipulationKeys` so cache invalidation stays predictable:
 * invalidating `all` flushes every dashboard query, `details()` flushes all
 * dashboard reads, and `detail({ approvalId })` flushes a single deal's
 * dashboard. Never write a literal key array outside this module — the
 * factory IS the schema.
 *
 * Keyed on approvalId alone: the BFF endpoint is
 * `/api/v1/approvals/{approvalId}/workbench/Dashboard` — no dealer in the path.
 */
export const dscWorkbenchKeys = {
  all: ["dscWorkbench"] as const,
  details: () => [...dscWorkbenchKeys.all, "detail"] as const,
  detail: (arguments_: DscWorkbenchKeyArguments) => [...dscWorkbenchKeys.details(), arguments_] as const,
};
